import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowMidDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "m35.6 26.029-10.1 10.1V8.25h-3v27.879l-10.1-10.1-2.121 2.121L24 41.871 37.722 28.15z" }) }) })
});
export default SvgArrowMidDown;
